import router from "@/router";
import axios from "axios";
import config from "@/config"



const state = {
    token: localStorage.getItem('token') || '',
    user: {},
    status: '',
    role: localStorage.getItem('role') || ''
}

const getters = {
    isLoggedIn: state => !!state.token,
    authState: state => state.status,
    user: state => state.user,
    role: state => state.role
}

const actions = {
    // Login action
    async login({commit}, user) {
        commit('auth_request');
        let res = await axios.post(`${config.apiBaseUrl}/api/users/login`,user)
        if (res.data.success) {
            const token = res.data.token
            const user = res.data.user
            const role = res.data.user.role //checking
            console.log(`${role} form auth js`)

            //Store the data into local storage
            localStorage.setItem('token', token)
            
            localStorage.setItem('role', role)


            //Set the axios defaults
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, user)
        }
        return res
    },

    // Register User
    async register({
        commit
    },userData){
        commit('register_request')
        let res = await axios.post(`${config.apiBaseUrl}/api/users/register-teacher`,userData)
        if(res.data.success != undefined){
            commit('register-success')
        }
        return res;
    },

    //Get the user profile
    async getProfile({commit}){
        commit('profile_request')
        let res = await axios.get(`${config.apiBaseUrl}/api/users/profile`)
        commit('user_profile', res.data.user)
        return res;
    },



    //Logout User
    async logout({
        commit
    }){
        await localStorage.removeItem('token')
        commit('logout')
        delete axios.defaults.headers.common['Authorization']
        router.push('/login')
        return
    },


    //Student Section

    // Add Student
    
    async addstudent({
        commit
    },StudentData){
        commit('add_request')
        let res = await axios.post(`${config.apiBaseUrl}/api/users/add-student`,StudentData)
        if(res.data.success != undefined){
            commit('add_success')

        }
        return res;
    },

    //get student lists 
    //not completed
    
    // async getStudents({commit}){
    //     commit('profile_request')
    //     let res = await axios.get('http://127.0.0.1:5000/api/users/get-student')
    //     commit('user_profile', res.data)
    //     return res;
    // },



}

const mutations = {
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, token, user) {
        state.token = token
        state.user = user
        state.status = 'success'
    },

    register_request(state){
        state.status = 'loading'
    },
    register_success(state){
        state.status = 'success'
    },

    add_request(state){
        state.status = 'loading'
    },
    add_success(state){
        state.status = 'success'
    },

    logout(state){
        state.status = ''
        state.token = ''
        state.user = ''
    },
    
    profile_request(state){
        state.status = 'loading'
    },
    user_profile(state, user){
        state.user = user
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}